
  import { defineComponent } from "vue";
  
  export default defineComponent({
    props: {
      leftIconDS: {
        type: String,
        required: false,
        default: "",
      },
      rightIconDS: {
        type: String,
        required: false,
        default: "",
      },
      leftIcon: {
        type: String,
        required: false,
        default: "",
      },
      rightIcon: {
        type: String,
        required: false,
        default: "",
      },
      text: {
        type: String,
        required: true,
        default: "",
      },
      isEnabled: {
        type: Boolean,
        default: true,
        required: false,
      },
      isDarkMode: {
        type: Boolean,
        default: false,
        required: false,
      },
      isError: {
        type: Boolean,
        default: false,
        required: false,
      },
      type: {
        type: String,
        default: "primary",
        required: true,
        validator(value: string): boolean {
          return ["primary", "secondary", "tertiary"].includes(value);
        },
      },
      action: {
        type: String,
        default: "button",
        required: false,
        validator(value: string): boolean {
          return ["button", "reset", "submit"].includes(value);
        },
      },
    },
    computed: {
      setupButton(): string | undefined {
        let className: string | undefined;
        if (this.type == "primary") {
          className = "button-primary btn btn-primary";
        } else if (this.type == "secondary") {
          className = "button-secondary btn btn-outline-primary";
        } else if (this.type == "tertiary") {
          className = "button-tertiary btn btn-tertiary";
        }
        return this.isError ? className + "-destructive" : className;
      },
      setupBackground(): string {
        return this.isDarkMode ? "btn-background-fill" : "btn-background";
      },
      setupMargins(): string {
        var margin = "";
        if (this.type != "tertiary") {
          return margin;
        }
        if (this.leftIcon == "") {
          margin += "btn-without-ml ";
        }
        if (this.rightIcon == "") {
          margin += "btn-without-mr";
        }
        if (this.leftIconDS == "") {
          margin += "btn-without-ml ";
        }
        if (this.rightIconDS == "") {
          margin += "btn-without-mr";
        }
        return margin;
      },
    },
  });
  